import React from "react";
import { EyeIcon, ClockIcon, ZapIcon, SearchIcon, ShareIcon, TargetIcon } from "lucide-react";
import { SectionCta } from "../SectionCta";
import { clinicalDistinctions } from "../../data/clinicalDecisions";
const icons = [EyeIcon, ClockIcon, ZapIcon, SearchIcon, ShareIcon, TargetIcon];
export function ClinicalDecisionSection() {
  return <section className="w-full bg-white px-5 py-16 sm:py-24" data-id="element-146" data-mp="3r9v5lwjtfgok">
      <div className="mx-auto max-w-4xl" data-id="element-147" data-mp="17ipc5xflew">
        <h2 className="text-center font-serif text-[28px] font-black leading-tight text-navy sm:text-4xl" data-id="element-148" data-mp="4rf34ozgyg">
          The Clinical Decision That Can Change How You Approach a Growing Patient
        </h2>
        <div className="mx-auto mt-6 max-w-2xl space-y-3 text-center text-lg text-muted" data-id="element-149" data-mp="9u52rmqkhifm">
          <p className="font-bold text-navy" data-id="element-150" data-mp="et800l0b2kd1">Not every developing malocclusion requires immediate treatment.</p>
          <p data-id="element-151" data-mp="iqvwvtlk6n7k">And not every orthodontic problem should be left until permanent dentition.</p>
          <p data-id="element-152" data-mp="npqtbycg8aa5">
            One of the most important challenges in interceptive orthodontics is knowing how to distinguish
            between:
          </p>
        </div>

        <ul className="mt-10 grid gap-3 sm:grid-cols-2" data-id="element-153" data-mp="86c4x932ondv">
          {clinicalDistinctions.map((item, i) => {
          const Icon = icons[i];
          return <li key={item} className="flex items-center gap-4 rounded-2xl bg-cream p-4" data-id="element-154" data-mp="3ueveudf9i622" data-mpi={i}>
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-wine text-white" data-id="element-155" data-mp="vx7v61rvraj0">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-156" data-mp="qyo81y1jvsp2" />
                </span>
                <span className="text-base font-semibold text-navy" data-id="element-157" data-mp="m6dbn560qp19">{item}</span>
              </li>;
        })}
        </ul>

        <blockquote className="mx-auto mt-12 max-w-2xl border-l-4 border-wine pl-5" data-id="element-158" data-mp="h7ac208t5b0o">
          <p className="font-serif text-2xl font-bold leading-snug text-navy sm:text-3xl" data-id="element-159" data-mp="1enze9v1o6fal">
            The challenge isn’t simply identifying a malocclusion.
          </p>
          <p className="mt-3 text-lg text-muted" data-id="element-160" data-mp="343tawlc1ge36">
            It’s understanding what the findings mean, whether intervention is indicated, and what should
            happen next.
          </p>
        </blockquote>
        <p className="mt-8 text-center text-lg font-bold text-wine" data-id="element-161" data-mp="2udgriwfymqym">
          That’s where a structured clinical framework becomes valuable.
        </p>

        <SectionCta label="I want to know when to intervene" data-id="element-162" data-mp="2zb9yhrp37ozy" />
      </div>
    </section>;
}